function openCardNotify(button) {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.id = `notify-variant-3dids-${Date.now()}`;
  input.value = button.dataset.notifyVariant;

  const trigger = document.createElement('a');
  trigger.className = 'btn klaviyo-bis-trigger';
  trigger.href = '#';
  trigger.hidden = true;
  trigger.dataset.klaviyoHandle = button.dataset.notifyHandle;
  trigger.dataset.klaviyoQuickviewVariant = `#${input.id}`;

  document.body.append(input, trigger);
  trigger.click();
  input.remove();
  trigger.remove();
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-notify-me-3dids]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  if (button.dataset.notifyHandle) {
    openCardNotify(button);
    return;
  }

  const scope = button.closest('product-form-component') || button.parentElement || document;
  const trigger = scope.querySelector('.klaviyo-bis-trigger') || document.querySelector('.klaviyo-bis-trigger');

  if (!trigger) return;

  document.body.dispatchEvent(new Event('change', { bubbles: true }));
  trigger.click();
}, true);

document.addEventListener('shopify:product:select', async (event) => {
  const source = event.target;
  if (!(source instanceof Element) || source.closest('product-card')) return;

  let result;
  try {
    result = await event.promise;
  } catch (error) {
    return;
  }

  const resource = result?.detail?.resource;
  const soldOut = Boolean(resource) && resource.available === false;
  const section = source.closest('.shopify-section') || document;

  section.querySelectorAll('[data-notify-wrap-3dids]').forEach((wrap) => {
    wrap.toggleAttribute('data-sold-out', soldOut);
    const button = wrap.querySelector('[data-notify-me-3dids]');
    if (button) button.hidden = !soldOut;
  });
});
